"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enums = exports.Subscription = exports.BillingPeriod = exports.BillingAddress = exports.Order = exports.RolloffOrder = exports.OrderPtloo = exports.OrderCommercial = exports.OrderItem = exports.ServiceLocation = exports.Location = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const customer_1 = require("../customer");
const payment_processing_1 = require("../invoice/payment-processing");
exports.Location = typebox_1.Type.Object({
    addressLine1: typebox_1.Type.Optional(typebox_1.Type.String()),
    addressLine2: typebox_1.Type.Optional(typebox_1.Type.String()),
    addressNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    city: typebox_1.Type.String(),
    country: typebox_1.Type.String(),
    /**
     * Service-location county. Required for NJ regulatory compliance reporting (waste haulers must
     * report activity by county).
     */
    county: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    latitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    longitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    sortOrder: typebox_1.Type.Optional(typebox_1.Type.Number()),
    state: typebox_1.Type.String(),
    zip: typebox_1.Type.String(),
});
exports.ServiceLocation = typebox_1.Type.Object({
    address: exports.Location,
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    gateCode: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    latitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    longitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    svcLocLocID: typebox_1.Type.Optional(typebox_1.Type.String()),
    svcLocOrderID: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.OrderItem = typebox_1.Type.Object({
    baseCost: typebox_1.Type.Optional(typebox_1.Type.Number()),
    baseRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    endTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordItemOrdID: typebox_1.Type.Optional(typebox_1.Type.String()),
    quantity: typebox_1.Type.Optional(typebox_1.Type.Number()),
    startTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxable: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    unitCost: typebox_1.Type.Optional(typebox_1.Type.Number()),
    unitRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.OrderCommercial = typebox_1.Type.Object({
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    deliveryDateActual: typebox_1.Type.Optional(typebox_1.Type.String()),
    deliveryDateRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    endTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    equipmentMaterial: typebox_1.Type.Optional(typebox_1.Type.String()),
    equipmentSizeRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    equipmentSizeUnit: typebox_1.Type.Optional(typebox_1.Type.String()),
    equipmentTypeRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordCommEqTypeIDNullable: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordCommEquipmentIDNullable: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordCommOrdID: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordCommVendorIDNullable: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
    pickupDateActual: typebox_1.Type.Optional(typebox_1.Type.String()),
    pickupDateRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    poNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    quantity: typebox_1.Type.Number(),
    serviceDays: typebox_1.Type.Optional(typebox_1.Type.String()),
    serviceFrequency: typebox_1.Type.Optional(typebox_1.Type.Number()),
    serviceFrequencyUnit: typebox_1.Type.Optional(typebox_1.Type.String()),
    soNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    sortOrder: typebox_1.Type.Optional(typebox_1.Type.Number()),
    startTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxable: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    unitCost: typebox_1.Type.Optional(typebox_1.Type.Number()),
    unitRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.OrderPtloo = typebox_1.Type.Object({
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    orderID: typebox_1.Type.Optional(typebox_1.Type.String()),
    startTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    endTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    eqParamOptionID: typebox_1.Type.Optional(typebox_1.Type.String()),
    deliveryDateRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    pickupDateRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    deliveryDateActual: typebox_1.Type.Optional(typebox_1.Type.String()),
    pickupDateActual: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorIDNullable: typebox_1.Type.Optional(typebox_1.Type.String()),
    poNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    soNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    serviceFrequency: typebox_1.Type.Optional(typebox_1.Type.Number()),
    serviceFrequencyUnit: typebox_1.Type.Optional(typebox_1.Type.String()),
    unitRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    unitCost: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    serviceDays: typebox_1.Type.Optional(typebox_1.Type.String()),
    sortOrder: typebox_1.Type.Optional(typebox_1.Type.Number()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.RolloffOrder = typebox_1.Type.Object({
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    /** Parent ord ID */
    orderID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    billingStatus: typebox_1.Type.Optional(typebox_1.Type.String()),
    requestedDeliveryDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    actualDeliveryDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    requestedPickupDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    actualPickupDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    material: typebox_1.Type.Optional(typebox_1.Type.String()),
    requestedSize: typebox_1.Type.Optional(typebox_1.Type.Number()),
    requestedType: typebox_1.Type.Optional(typebox_1.Type.String()),
    expectedSize: typebox_1.Type.Optional(typebox_1.Type.Number()),
    expectedType: typebox_1.Type.Optional(typebox_1.Type.String()),
    containerTypeID: typebox_1.Type.Optional(typebox_1.Type.String()),
    containerName: typebox_1.Type.Optional(typebox_1.Type.String()),
    weightLimit: typebox_1.Type.Optional(typebox_1.Type.Number()),
    originalRentalPeriod: typebox_1.Type.Optional(typebox_1.Type.Number()),
    adjustedRentalPeriod: typebox_1.Type.Optional(typebox_1.Type.Number()),
    /** Rent-extension fee in cents */
    rentExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Number()),
    /** Overage fee in cents */
    overageFee: typebox_1.Type.Optional(typebox_1.Type.Number()),
    poNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    orderNumber: typebox_1.Type.Optional(typebox_1.Type.Number()),
    /** Position within a switch chain; the lowest value is the chain head. */
    sortOrder: typebox_1.Type.Optional(typebox_1.Type.Number()),
    dumpTicketNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    dumpRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    haulCost: typebox_1.Type.Optional(typebox_1.Type.Number()),
    dumpCost: typebox_1.Type.Optional(typebox_1.Type.Number()),
    /** Denormalized from parent ord */
    serviceLocation: typebox_1.Type.Optional(exports.ServiceLocation),
    /** Denormalized from customer record */
    customer: typebox_1.Type.Optional(customer_1.BaseCustomer),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.Order = typebox_1.Type.Object({
    commercialOrder: typebox_1.Type.Optional(typebox_1.Type.Array(exports.OrderCommercial)),
    orderPtloo: typebox_1.Type.Optional(typebox_1.Type.Array(exports.OrderPtloo)),
    orderRo: typebox_1.Type.Optional(typebox_1.Type.Array(exports.RolloffOrder)),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.String(),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    oneTimeCharges: typebox_1.Type.Optional(typebox_1.Type.Array(exports.OrderItem)),
    ordSubID: typebox_1.Type.String(),
    ordSvcLocID: typebox_1.Type.Optional(typebox_1.Type.String()),
    recurringCharges: typebox_1.Type.Optional(typebox_1.Type.Array(exports.OrderItem)),
    serviceLocation: exports.ServiceLocation,
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.BillingAddress = typebox_1.Type.Object({
    addressLine1: typebox_1.Type.String(),
    addressLine2: typebox_1.Type.Optional(typebox_1.Type.String()),
    city: typebox_1.Type.Optional(typebox_1.Type.String()),
    country: typebox_1.Type.Optional(typebox_1.Type.String()),
    state: typebox_1.Type.Optional(typebox_1.Type.String()),
    zip: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.BillingPeriod = typebox_1.Type.Object({
    autopaySource: typebox_1.Type.Optional(typebox_1.Type.String()),
    autopayProcessor: typebox_1.Type.Optional(payment_processing_1.AutopaySourceProcessorTransport),
    billPeriodSubID: typebox_1.Type.String(),
    billingDay: typebox_1.Type.Optional(typebox_1.Type.Number()),
    billingTerm: typebox_1.Type.Optional(typebox_1.Type.Number()),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    endTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    number: typebox_1.Type.Optional(typebox_1.Type.Number()),
    orders: typebox_1.Type.Optional(typebox_1.Type.Array(exports.Order)),
    startTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    subscriptionNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxPercent: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.Subscription = typebox_1.Type.Object({
    accountExecutive: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountManager: typebox_1.Type.Optional(typebox_1.Type.String()),
    autopaySource: typebox_1.Type.Optional(typebox_1.Type.String()),
    autopayProcessor: typebox_1.Type.Optional(payment_processing_1.AutopaySourceProcessorTransport),
    billingAddress: typebox_1.Type.Optional(exports.BillingAddress),
    billingDay: typebox_1.Type.Optional(typebox_1.Type.Number()),
    billingFrequency: typebox_1.Type.String(),
    billingTerm: typebox_1.Type.Optional(typebox_1.Type.Number()),
    billingType: typebox_1.Type.Optional(common_1.PaymentMethod),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customer: typebox_1.Type.Optional(customer_1.BaseCustomer),
    customerID: typebox_1.Type.String(),
    endTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    futureServicePeriodCount: typebox_1.Type.Optional(typebox_1.Type.Number()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    number: typebox_1.Type.Optional(typebox_1.Type.String()),
    orders: typebox_1.Type.Array(exports.Order),
    poNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    soNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    startTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    subscriptionType: typebox_1.Type.Optional(typebox_1.Type.Union([
        typebox_1.Type.Literal('ORDER_PT_LOO'),
        typebox_1.Type.Literal('ORDER_RO'),
        typebox_1.Type.Literal('ORDER_COMMERCIAL'),
        typebox_1.Type.Literal('UNKNOWN'),
    ])),
    taxPercent: typebox_1.Type.Optional(typebox_1.Type.Number()),
    createdTimeZone: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdUtcOffset: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.Enums = __importStar(require("./enums"));
//# sourceMappingURL=operations.js.map